// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorPage_container__hd8cy","wrapper":"ErrorPage_wrapper__3tcch","image":"ErrorPage_image__kMImW"};